export default {
  username: {
    step: 1,
    name: 'username',
    icon: 'user',
    h1: "Let's Verify Your Identity!",
    h2: 'Enter your username.',
    back: null,
    next: 'ssnDob'
  },
  ssnDob: {
    step: 3,
    name: 'ssnDob',
    icon: 'key',
    h1: "Next, we'll need your Social Security number.",
    h2: 'Enter the last four digits of your Social Security number or Tax ID number.',
    back: 'username',
    next: 'dob'
  }
}
